import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from 'react-redux';
import { getParams } from '../../common/utils';
import { hasPermission, apiPost, getHostApi } from '../../../store/apiWrapper';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { searchActions, propertySkSearchBy, searchStatus } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import Section from '../../common/section';
import ExcelExportButton from '../../common/excelExportButton';
import { toast } from '../../common/toast';
import BasicRow from '../../reportSections/identData/basicRow';

import './propertySk.scss';

class PropertySkOwnershipDocument extends React.Component {
    mounted = false;

    componentDidMount() {
        this.mounted = true;
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search), false);
            if (!isNullOrUndefined(params))
                this.props.propertySkSearch(params);
        }
    }

    componentDidUpdate() {
        if (!this.mounted)
            return;

        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search), false);
            if (this.props.languageChanged || (!isNullOrUndefined(params) && !isEqual(this.props.search.params, params)))
                this.props.propertySkSearch(params);
        }
    }

    openCompleteDoc = () => {
        const params = this.parseParams(getParams(window.location.search), true);
        this.props.history.push(`/search/property-sk/ownership-deed?cadastreUnitId=${params.cadastreUnitId}&ownershipDeedNo=${params.ownershipDeedNo}`);
        this.props.propertySkSearch(params);
    }

    openPropertyReportPerson = (hash) => {
        this.props.history.push(`/search/property-sk/report?searchBy=4&hash=${hash}`);
    }

    openPropertyReportCompany = (entityId) => {
        this.props.history.push(`/search/property-sk/report?searchBy=3&entityId=${entityId}`);
    }

    propertyReportLink = (owner) => {
        if (!hasPermission(null, "CadastreSkReport"))
            return <>{owner.nameAddress}<br /></>
        if (!isNullOrUndefined(owner.entityId))
            return <span className="link-internal" onClick={() => this.openPropertyReportCompany(owner.entityId)}>{owner.nameAddress}</span>
        if (!isNullOrUndefined(owner.hash) && owner.hash !== '')
            return <span className="link-internal" onClick={() => this.openPropertyReportPerson(owner.hash)}>{owner.nameAddress}</span>

        return <>{owner.nameAddress}<br /></>
    }

    render() {
        if (this.props.search.status === searchStatus.requested)
            return <Circles />;

        if (this.props.search.status === searchStatus.idle)
            return <NoDataComponent />;

        if (this.props.search.status === searchStatus.error) {
            return (<div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                <Message type="warning" options={{ renderInnerHtml: true }} message={this.props.translate(this.props.search.error.message)} />
            </div>)
        }

        if (isNullOrUndefined(this.props.search.data) || isNullOrUndefined(this.props.search.data.generalInfo))
            return <NoDataComponent />;

        var data = this.props.search.data;
        const params = getParams(window.location.search);

        var otherInfos = [];
        var burdens = [];
        if (!isNullOrUndefined(data.charges)) {
            burdens = data.charges.filter(function (val) { return val.documentType === 1 });
            otherInfos = data.charges.filter(function (val) { return val.documentType === 2 });
        }
        var agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return <>
            {this.renderReportDateInformation()}
            <div className='card'>
                <div className='card-body'>
                    {!data.isComplete && <span className="link-internal" onClick={() => this.openCompleteDoc()}><Translate id="PropertySk.Document.FullOwnershipDeed" /></span>}
                    <div className="ident-data">
                        {this.renderBasicRow("PropertySk.Search.Region", data.generalInfo.region, false)}
                        {this.renderBasicRow("PropertySk.Search.District", data.generalInfo.district, false)}
                        {this.renderBasicRow("PropertySk.Search.Municipality", data.generalInfo.municipality, false)}
                        {this.renderBasicRow("PropertySk.Search.CadastreUnit", data.generalInfo.cadastreUnit, false)}
                        {this.renderBasicRow("PropertySk.Search.OwnershipDeedNo", params.ownershipDeedNo, !data.isComplete)}
                    </div>

                    <div style={{ display: "flex", marginTop: "1em" }}>
                        <div style={{ display: "flex", flex: "1 1 0px" }}>
                            <ExcelExportButton style={{ margin: "1em 1em 1em 0" }}
                                onClick={() => this.exportToExcel(data.generalInfo.cadastreUnit)}
                            />
                        </div>

                        {((!isNullOrUndefined(data.parcels) && data.parcels.length > 0) ||
                            (!isNullOrUndefined(data.flats) && data.flats.length > 0) ||
                            (!isNullOrUndefined(data.buildings) && data.buildings.length > 0)) &&
                            <span className='underlined-title-wrapper' style={{ margin: "1em 0" }}>
                                <span className='underlined-title'><Translate id="PropertySk.Document.Properties" /></span>
                            </span>
                        }
                        <div style={{ flex: "1 1 0px" }} />
                    </div>

                    {!isNullOrUndefined(data.parcels) && data.parcels.length > 0 && this.renderParcels(data.parcels)}
                    {!isNullOrUndefined(data.flats) && data.flats.length > 0 && this.renderFlats(data.flats)}
                    {!isNullOrUndefined(data.buildings) && data.buildings.length > 0 && this.renderBuildings(data.buildings)}
                    {((!isNullOrUndefined(data.personOwners) && data.personOwners.length > 0) ||
                        (!isNullOrUndefined(data.companyOwners) && data.companyOwners.length > 0)) && this.renderOwners((data.personOwners || []).concat(data.companyOwners), (data.personOwnersDocuments || []).concat(data.companyOwnersDocuments))}
                    {burdens.length > 0 && this.renderCharges(burdens, 'PropertySk.Document.Burdens')}
                    {otherInfos.length > 0 && this.renderCharges(otherInfos, 'PropertySk.Document.OtherInformation')}
                    {!isNullOrUndefined(data.notes) && data.notes.length > 0 && this.renderNotesTitles(data.notes, 'PropertySk.Document.Notes')}
                    {!isNullOrUndefined(data.otherSealsInfo) && data.otherSealsInfo.length > 0 && this.renderOtherSealsInfo(data.otherSealsInfo)}
                    {!isNullOrUndefined(data.acquisitionsWithoutCoowner) && data.acquisitionsWithoutCoowner.length > 0 && this.renderNotesTitles(data.acquisitionsWithoutCoowner, 'PropertySk.Document.TitlesOfAcquisition')}
                </div>
            </div>
            <div className="disclaimer-wrapper">
                <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                <hr className="report-component-hr" style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                <div className="disclaimer-gray">
                    <Translate id="PropertySk.Document.Disclaimer1" /> <Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                </div>
            </div>
        </>
    }

    exportToExcel = (cadastreUnitName) => {
        var params = this.parseParams(getParams(window.location.search), false);
        params.language = this.props.user.language;
        params.cadastreUnitName = cadastreUnitName;
        apiPost(getHostApi() + `/api/cadastre-sk/ownership-deed/excel-export`, undefined, params, undefined,
            () => toast(this.props.translate("UnhappyUser.InternalServerError"), "error"));
    }

    renderReportDateInformation() {
        return (
            <div className="property-sk-query-date">
                <div>
                    <span className="bold"><Translate id="Report.Date" />:&nbsp;</span>
                    <span className="bold"><MomentDate value={new Date()} /></span>
                </div>
            </div>
        );
    }

    renderBasicRow = (trKey, value, link) =>
        <BasicRow title={trKey} value={link ? <a className="link-internal" onClick={() => this.openCompleteDoc()}>{value}</a> : value} />

    renderParcels = (parcels) => {
        return (
            <Section name={this.props.translate("PropertySk.Document.Lands")} isOpen>
                <table className="table table-report-section fixed table-stretched">
                    <thead className="property-sk-parcels-header">
                        <tr>
                            <th className="col-1"><Translate id="PropertySk.Document.RegisterType" /></th>
                            <th className="col-2"><Translate id="PropertySk.Document.LandId" /></th>
                            <th className="col-3"><Translate id="PropertySk.Document.Area" /></th>
                            <th className="col-4"><Translate id="PropertySk.Document.LandType" /></th>
                            <th className="col-5"><Translate id="PropertySk.Document.LandUtilization" /></th>
                            <th className="col-6"><Translate id="PropertySk.Document.TypeOfProtectedProp" /></th>
                            <th className="col-7"><Translate id="PropertySk.Document.Location" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {parcels.map((p, i) => <React.Fragment key={i}>
                            <tr>
                                <td>{p.registryType}</td>
                                <td>{p.landId}</td>
                                <td>{p.area}</td>
                                <td>{p.landType}</td>
                                <td>{p.landUse}</td>
                                <td>{p.propertyProtectedTypes}</td>
                                <td>{p.location}</td>
                            </tr>
                            {p.buildingOwnershipDocumentNumber && <tr>
                                <td colSpan="7" align="center">{this.props.translate('PropertySk.Document.OwnershipOfTheBuilding').replace('{0}', p.buildingOwnershipDocumentNumber)}</td>
                            </tr>}
                            {p.seals.map(s => this.renderSeal(s, 7))}
                        </React.Fragment>
                        )}
                    </tbody>
                </table>
            </Section>
        );
    }

    renderFlats = (flats) => {
        return (
            <Section name={this.props.translate("PropertySk.Document.FlatAndNonFlatSpaces")} isOpen>
                <table className="table table-report-section fixed table-stretched">
                    <thead className="property-sk-flats-header">
                        <tr>
                            <th className="col-1"><Translate id="PropertySk.Document.SeqNum" /></th>
                            <th className="col-2"><Translate id="PropertySk.Document.SpaceType" /></th>
                            <th className="col-3"><Translate id="PropertySk.Document.Floor" /></th>
                            <th className="col-4"><Translate id="PropertySk.Document.FlatNum" /></th>
                            <th className="col-5"><Translate id="PropertySk.Document.Gate" /></th>
                            <th className="col-6"><Translate id="PropertySk.Document.NonFlatNum" /></th>
                            <th className="col-7"><Translate id="PropertySk.Document.PropertyRegNum" /></th>
                            <th className="col-8"><Translate id="PropertySk.Document.CommonAreaPart" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {flats.map((f, i) => <React.Fragment key={i}>
                            <tr>
                                <td>{f.coownerId}</td>
                                <td>{f.spaceType}</td>
                                <td>{this.renderFloor(f.floor)}</td>
                                <td>{f.flatNumber}</td>
                                <td>{f.gate}</td>
                                <td>{f.nonFlatNumber}</td>
                                <td>{f.registrationNumber}</td>
                                <td>{f.commonAreaNumerator} / {f.commonAreaDenominator}</td>
                            </tr>
                            {f.seals.map(s => this.renderSeal(s, 8))}
                        </React.Fragment>
                        )}
                    </tbody>
                </table>
            </Section>
        );
    }

    renderSeal = (seal, colSpan) => {
        return <tr key={seal.id}>
            <td colSpan={colSpan} align="center" style={{ color: 'red' }}>
                <Translate id="PropertySk.Document.SealIndicatedOnTheBasisOf" /> {seal.submissionNumber} <Translate id="PropertySk.Document.On" /> {seal.submissionDateFormatted}
            </td>
        </tr>
    }

    renderFloor = (floor) => {
        if (isNullOrUndefined(floor) || floor === '')
            return null;
        // Work with floor multiplied by 10 as integer to prevent from rounding errors
        var floorAsInt = Math.round(floor * 10);

        // Ground floor 0.0
        if (floorAsInt === 0) {
            return this.props.translate('PropertySk.Document.FlatGroundFloor');
        }
        // Basement -1.0
        else if (floorAsInt === -10) {
            return this.props.translate('PropertySk.Document.FlatBasement');
        }
        // Floor X.0, -X.0
        else if (floorAsInt % 10 === 0) {
            return (floorAsInt / 10) + this.props.translate('PropertySk.Document.FlatFloorAbbreviation');
        }
        // Mezzanine X.5, -X.5
        else if (floorAsInt % 5 === 0) {
            return (floorAsInt / 10) + '. ' + this.props.translate('PropertySk.Document.FlatMezzanine');
        }
        // Loft X.9
        else if (floorAsInt > 0 && (floorAsInt - 9) % 10 === 0) {
            return this.props.translate('PropertySk.Document.FlatLoft');
        }
        // another undocumented cases -> should not never reach
        else {
            return floor;
        }
    }

    renderBuildings = (buildings) => {
        return (
            <Section name={this.props.translate("PropertySk.Document.Buildings")} isOpen>
                <table className="table table-report-section table-stretched">
                    <thead>
                        <tr>
                            <th><Translate id="PropertySk.Document.PropertyRegNum" /></th>
                            <th><Translate id="PropertySk.Document.LandId" /></th>
                            <th><Translate id="PropertySk.Document.BuildingType" /></th>
                            <th><Translate id="PropertySk.Document.BuldingDesc" /></th>
                            <th><Translate id="PropertySk.Document.Location" /></th>
                            <th><Translate id="PropertySk.Document.TypeOfProtectedProp" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {buildings.map(b => <React.Fragment key={b.id}>
                            <tr>
                                <td>{b.registrationNumber}</td>
                                <td>{b.landId}</td>
                                <td>{b.buildingType}</td>
                                <td>{b.description}</td>
                                <td>{b.location}</td>
                                <td>{b.protectedPropertyType === '0' ? null : b.protectedPropertyType}</td>
                            </tr>
                            {b.landOwnershipDocumentNumber && <tr>
                                <td colSpan="6" align="center">{this.props.translate('PropertySk.Document.OwnershipOfTheLandUnder').replace('{0}', b.landOwnershipDocumentNumber)}</td>
                            </tr>}
                            {b.seals.map(s => this.renderSeal(s, 6))}
                        </React.Fragment>
                        )}
                    </tbody>
                </table>
            </Section>
        );
    }

    renderOwners = (owners, ownersDocs) => {
        return (
            <Section name={this.props.translate("PropertySk.Document.Owners")} isOpen>
                <table className="table table-report-section table-stretched">
                    <thead>
                        <tr>
                            <th><Translate id="PropertySk.Document.SeqNum" /></th>
                            <th><Translate id="PropertySk.Document.SurnameFirstnameEtc" /><br /><Translate id="PropertySk.Document.DobCompanyId" /></th>
                            <th><Translate id="PropertySk.Document.CoownerPart" /><br /><Translate id="PropertySk.Document.PartyOfTheLegal" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {owners.map(o => <React.Fragment key={o.id}>
                            <tr>
                                <td>{o.coownerId}</td>
                                <td>
                                    {this.propertyReportLink(o)}
                                    {o.companyId}{o.birthDate && <>{o.birthDateFormated}</>}{o.birthDateCoowner && <>,&nbsp;{o.birthDateCoownerFormated}</>}
                                </td>
                                <td>{o.shareNumerator}/{o.shareDenominator}<br />{o.relationType}</td>
                            </tr>
                            {
                                this.titlesOfAcquisition(o.coownerId, ownersDocs).length > 0 && <tr>
                                    <td colSpan="3">
                                        {this.titlesOfAcquisition(o.coownerId, ownersDocs).map(t => <React.Fragment key={t.id}>
                                            <b>{t.documentType === 4 ? <Translate id="PropertySk.Document.Note" /> : <Translate id="PropertySk.Document.TitleOfAcquisition" />}: </b>
                                            {t.documentBody}
                                            <br />
                                        </React.Fragment>
                                        )}
                                    </td>
                                </tr>
                            }
                            {o.seals.map(s => this.renderSeal(s, 3))}
                        </React.Fragment>
                        )}
                    </tbody>
                </table>
            </Section>
        );
    }

    titlesOfAcquisition = (coownerId, ownersDocs) => {
        return ownersDocs.filter(function (val) { return val.coownerId === coownerId });
    }

    renderCharges = (charges, header) => {
        return (
            <Section name={this.props.translate(header)} isOpen>
                <table className="table table-report-section table-stretched">
                    <thead>
                        <tr>
                            <th><Translate id="PropertySk.Document.SeqNum" /></th>
                            <th><Translate id="PropertySk.Document.Text" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {charges.map(ch => <tr key={ch.id}>
                            <td>{ch.coownerId}</td>
                            <td>{ch.documentBody}</td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </Section>
        );
    }

    renderNotesTitles = (notes, header) => {
        return (
            <Section name={this.props.translate(header)} isOpen>
                <table className="table table-report-section table-stretched table-bordered">
                    <thead>
                        <tr>
                            <th><Translate id="PropertySk.Document.Text" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {notes.map(n => <tr key={n.id}>
                            <td>{n.documentBody}</td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </Section>
        );
    }

    renderOtherSealsInfo = (seals) => {
        return (
            <table className="table table-report-section table-stretched table-bordered">
                <tbody>
                    {seals.map((s) => this.renderSeal(s, 1))}
                </tbody>
            </table>
        );
    }

    parseParams = (params, completeDoc) => {
        const companyId = isNullOrUndefined(params.companyId) ? null : parseInt(params.companyId);

        const result = {
            searchBy: completeDoc ? propertySkSearchBy.document :
                !isNullOrUndefined(params.companyId) ? propertySkSearchBy.documentCompany :
                    !isNullOrUndefined(params.hash) ? propertySkSearchBy.documentPerson :
                        propertySkSearchBy.document,
            cadastreUnitId: parseInt(params.cadastreUnitId),
            ownershipDeedNo: parseInt(params.ownershipDeedNo)
        };

        if (!isNullOrUndefined(params.hash))
            result.hash = params.hash;
        if (!isNullOrUndefined(companyId) && !isNaN(companyId))
            result.companyId = companyId

        return result;
    };
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.propertySk }, layout: state.layout, languageChanged: state.search.languageChanged, user: state.userContext }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertySkOwnershipDocument)));
